import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Element } from 'react-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Header from './components/Header';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Carousel from './components/Carousel';
import FeaturedProperty from './components/FeaturedProperty';
import BookTour from './components/BookTour';
import Testimonials from './components/Testimonials';
import './App.css';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200, 
      once: true,   
    });
  }, []);

  return (
    <Router>
      <div>
        <Header />

        <Element name="hero">
          <Hero  /> 
        </Element>
        
        <Element name="about">
          <AboutUs /> 
        </Element>

        <div className="attractions" data-aos="zoom-in">
          <h1>Sagamu-Ikenne Attractions</h1>
          <Carousel />
        </div>

        <Element name="properties">
          <FeaturedProperty /> 
        </Element>

        <Testimonials />

        <Element name="contact">
          <BookTour  />
        </Element>
      </div>
    </Router>
  );
};

export default App;
